/* global I18n */

import vimeoManager from "vimeo_manager"
import React, {useState, useEffect} from "react"
import FeedbackIcon from "components/feedback_icon"
import classNames from "classnames"
import FaIcon from "components/fa_icon"

export default ({iframe, vimeoId}) => {
  function getFeedbackData() {
    vimeoManager.pauseVideo(iframe)
    const playtimeInSeconds = vimeoManager.getCurrentTime(iframe)
    return {
      vimeoId,
      currentPlaytime: playtimeInSeconds,
      contentFeedback: "video"
    }
  }
  // https://reactjs.org/blog/2017/11/28/react-v16.2.0-fragment-support.html
  return (
    <>
      {!!window.gon.currentUser &&
        <div className="embedded-video__feedback">
          <FeedbackIcon
            title={I18n.t("js.embedded_video.feedback_for_video")}
            getFeedbackData={getFeedbackData}
          />
        </div>}
      <VideoSkip iframe={iframe} />
      <PlaybackSpeed iframe={iframe} />
    </>
  )
}

function PlaybackSpeed({iframe}) {
  const [currentSpeed, setCurrentSpeed] = useState(1)
  useEffect(() => {
    function callback({playbackRate}) {
      setCurrentSpeed(playbackRate)
    }
    vimeoManager.on(iframe, "playbackratechange", callback)
    return () => vimeoManager.off(iframe, "playbackratechange", callback)
  })
  function changeSpeed(e, speed) {
    e.preventDefault()
    setCurrentSpeed(speed)
    vimeoManager.setPlaybackRate(iframe, speed)
  }
  function speedRateLink(rate) {
    return (
      <a
        className={classNames({active: currentSpeed === rate})}
        onClick={(e) => changeSpeed(e, rate)}
      >
        {`${rate}x`}
      </a>
    )
  }

  return (
    <div className="video-playback-speed">
      {I18n.t("js.videos.show.speed")}
      {currentSpeed === 0.5 &&
        <>
          {speedRateLink(0.5)}
          {" | "}
        </>}
      {currentSpeed === 0.75 &&
        <>
          {speedRateLink(0.75)}
          {" | "}
        </>}
      {speedRateLink(0.8)}
      {" | "}
      {speedRateLink(0.9)}
      {" | "}
      {speedRateLink(1)}
      {" | "}
      {speedRateLink(1.25)}
      {" | "}
      {speedRateLink(1.5)}
      {currentSpeed === 2 &&
        <>
          {" | "}
          {speedRateLink(2)}
        </>}
    </div>
  )
}

function VideoSkip({iframe}) {
  function skipForward(e) {
    e.preventDefault()
    return vimeoManager.skip(iframe, 10)
  }
  function skipBackward(e) {
    e.preventDefault()
    return vimeoManager.skip(iframe, -10)
  }
  return (
    <div className="video-skipper">
      <a onClick={skipBackward} href="" className="align-baseline">
        <FaIcon name={"fa-replay-10"} />
      </a>
      <a onClick={skipForward} href="" className="align-baseline">
        <FaIcon name={"fa-forward-10"} />
      </a>
    </div>
  )
}
